import { Database, MessageSquare, Shield, Sparkles, Users, History, BarChart3, UserPlus, Inbox, FilePlus } from "lucide-react";
import { NavLink } from "@/components/NavLink";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  useSidebar,
} from "@/components/ui/sidebar";
import { Badge } from "@/components/ui/badge";

const menuItems = [
  { title: "All Profiles", url: "/admin/profiles", icon: Database },
  { title: "Join Requests", url: "/admin/join-requests", icon: Inbox },
  { title: "Create Profile", url: "/admin/create-profile", icon: FilePlus },
  { title: "Smart Matcher", url: "/admin/smart-matcher", icon: Sparkles },
  { title: "Mutual Matches", url: "/admin/mutual-matches", icon: Users },
  { title: "Match History", url: "/admin/history", icon: History },
  { title: "Analytics", url: "/admin/analytics", icon: BarChart3 },
  { title: "Feedback & Bugs", url: "/admin/feedback", icon: MessageSquare },
  { title: "Matchmaker Signups", url: "/admin/matchmaker-signups", icon: UserPlus },
];

export function AdminSidebar() {
  const { open } = useSidebar();

  return (
    <Sidebar className={open ? "w-60" : "w-14"} collapsible="icon">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="flex items-center gap-2">
            {open && (
              <>
                <Shield className="h-4 w-4" />
                Admin Panel
                <Badge variant="destructive" className="text-xs">Admin</Badge>
              </>
            )}
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink 
                      to={item.url} 
                      end={item.url === "/admin/profiles"}
                      className="hover:bg-muted/50" 
                      activeClassName="bg-muted text-primary font-medium"
                    >
                      <item.icon className="h-4 w-4" />
                      {open && (
                        <span>{item.title}</span>
                      )}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}
